import React, {RefObject, forwardRef} from 'react'
import {
  Wrapper,
  Title,
  Content,
  KeyWrapper,
  Caution
} from './style'
type FormProps = {
  ref: RefObject<HTMLDivElement>,
  title: string,
  type: string,
  value: any,
  required?: boolean,
  caution?: string,
  pattern?: string,
  placeholder?: string,
  options?: {value: string, label: string}[],
  error?: boolean,
  readOnly?: boolean,
  onChange?: (event: React.ChangeEvent<HTMLInputElement|HTMLSelectElement>) => void,
}
const Form = forwardRef<HTMLDivElement, FormProps>((props, ref) => {
  return (
    <Wrapper ref={ref}>
      <KeyWrapper>
        <Title required={props.required}>
          {props.title}
        </Title>
        <Caution>{props.caution}</Caution>
      </KeyWrapper>
      <Content error={props.error}>
        { props.type === "select"
          && !props.readOnly
          && props.options ?
          (
            <select 
              value={props.value}
              onChange={props.onChange}
            >
              {props.options.map((option) => {
                return (
                  <option value={option.value}>{option.label}</option>
                )
              })}
            </select>)
          : ( 
            <input
              type={props.type}
              value={props.value}
              pattern={props.pattern}
              placeholder={props.placeholder}
              onChange={props.onChange}
              required={props.required}
              readOnly={props.readOnly} 
            />
          )
        }
      </Content>
    </Wrapper>
  )
})

export default Form;
